// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__1x7za","obliqueLineWrap":"membershipbadge_obliqueLineWrap__1r0gh","obliqueLine":"membershipbadge_obliqueLine__2WMgW"};